import React from "react";
import Icon from "@mdi/react";
import { mdiCartCheck } from "@mdi/js";
import moment from "moment";
import Pagination from "react-js-pagination";

const PAGE_SIZE = 20;
const STATUS_LABEL = { 0: "Chờ báo giá", 1: "Đã báo giá" };

export default function TableBaoGiaDaiLy({
  quotes, total, loading, pageIndex, onPageChange, onOpenDetail, onOpenOrder,
}) {
  const renderRows = () => {
    if (loading)
      return <tr><td colSpan={5} className="giaodich-empty">Đang tải...</td></tr>;

    if (!quotes.length)
      return <tr><td colSpan={5} className="giaodich-empty">Không có dữ liệu</td></tr>;

    return quotes.map((q, idx) => (
      <tr key={q.BaoGiaDaiLyID}>
        <td className="text-center">{(pageIndex - 1) * PAGE_SIZE + idx + 1}</td>

        <td className="text-left">
          <a
            href={() => false}
            className="iconTable-Main iconW18"
            onClick={(e) => { e.preventDefault(); onOpenDetail(q.BaoGiaDaiLyID); }}
          >
            {q.MaBaoGia}
          </a>
        </td>

        <td className="text-center">
          {q.CreatedTime ? moment(q.CreatedTime).format("DD/MM/YYYY HH:mm:ss") : ""}
        </td>

        <td className="text-center">{STATUS_LABEL[q.Approval] ?? ""}</td>

        <td className="text-center">
          {q.Approval === 1 && (
            <a
              href={() => false}
              className="iconTable-Main"
              title="Tạo đơn đặt hàng"
              onClick={(e) => { e.preventDefault(); onOpenOrder(q.BaoGiaDaiLyID, q.MaBaoGia); }}
            >
              <Icon path={mdiCartCheck} size={1.3} color="#02499b" />
            </a>
          )}
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div className="giaodich-summary">
        <div className="giaodich-summary-item">
          <span>Tổng số:</span>
          <b>{total} đơn báo giá</b>
        </div>
      </div>

      <div className="giaodich-table-wrap">
        <table className="giaodich-table">
          <thead>
            <tr>
              <th className="text-center">STT</th>
              <th className="text-left">Mã báo giá</th>
              <th className="text-center">Thời gian</th>
              <th className="text-center">Trạng thái</th>
              <th className="text-center">Thao tác</th>
            </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
        </table>
      </div>

      {total > PAGE_SIZE && (
        <div className="paggination-ver2 text-center pagination-Main justify-content-center">
          <div className="total-page">Tổng số {total} bản ghi</div>
          <Pagination
            activePage={pageIndex}
            itemsCountPerPage={PAGE_SIZE}
            totalItemsCount={total}
            pageRangeDisplayed={10}
            onChange={onPageChange}
            hideNavigation
            itemClass="cssPage-item"
            linkClass="cssPageLink"
            activeClass="cssActiveClass"
          />
        </div>
      )}
    </>
  );
}
